import React, {
  useState
} from "react";

import {
  Card,
  CardBody,
  Content,
  Grid,
  GridItem,
  Label,
  PageSection,
  Stack,
  StackItem,
  Tab,
  Tabs,
  TabTitleText,
  Divider,
  CardFooter,
  Flex,
  FlexItem,
  LabelGroup,
  CardHeader
} from "@patternfly/react-core";

import {
  CalendarAltIcon
} from "@patternfly/react-icons";

const InternshipsContent = ({
  internships = {}
}) => {
  const {
    introduction,
    totalHours,
    totalWeeks,
    stages = [],
    workplaces = []
  } = internships;

  return (
    <Stack hasGutter>
      {introduction && (
        <StackItem>
          <Content>
            <p>{introduction}</p>
          </Content>
        </StackItem>
      )}

      {(totalHours || totalWeeks) && (
        <StackItem>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "var(--pf-t--global--spacer--sm)"
            }}
          >
            {totalHours && (
              <Label color="blue">
                Łącznie: {totalHours} godzin
              </Label>
            )}

            {totalWeeks && (
              <Label
                color="blue"
                variant="outline"
              >
                {totalWeeks} tygodni
              </Label>
            )}
          </div>
        </StackItem>
      )}

      {stages.length > 0 && (
        <StackItem>
          <Grid hasGutter>
            {stages.map((stage) => (
              <GridItem
                key={`${stage.grade}-${stage.semester}`}
                span={12}
                md={6}
              >
                <Card
                  isCompact
                  isFullHeight
                >
                  <CardBody>
                    <Content>
                      <h3>{stage.grade}</h3>

                      <p>
                        <strong>{stage.semester}</strong>
                      </p>

                      <p>
                        {stage.hours} godzin
                        {" / "}
                        {stage.weeks} tygodnie
                      </p>
                    </Content>
                  </CardBody>
                </Card>
              </GridItem>
            ))}
          </Grid>
        </StackItem>
      )}

      {workplaces.length > 0 && (
        <>
        <StackItem>
          <Content>
            <h3>Gdzie mogą odbywać się praktyki?</h3>
          </Content>
        </StackItem>
        <Divider />
        <StackItem>  
          {/* <List> */}
          <LabelGroup
            collapsedText='${remaining} więcej'
            expandedText='Pokaż mniej'
            defaultIsOpen={true}
          >
            {workplaces.map((workplace) => (
              // <ListItem key={workplace}>
              <Label key={workplace}>
                <Content component="strong">{workplace}</Content>
              </Label>
              // </ListItem>
            ))}
          </LabelGroup>
          {/* </List> */}
        </StackItem>
        </>
      )}
    </Stack>
  );
};


const ExamsContent = ({
  exams = [],
  examInformation
}) => {
  return (
    <Stack hasGutter>
      {exams.length > 0 && (
        <StackItem>
          <Grid hasGutter>
            {exams.map((exam) => (
              <GridItem
                key={exam.code}
                span={12}
                md={6}
              >
                <Card
                  isCompact
                  isFullHeight
                >
                  <CardBody>
                    <Stack hasGutter>
                      <StackItem>
                        <Label
                          color="blue"
                          // variant="outline"
                        >
                          {exam.code}
                        </Label>
                      </StackItem>

                      <StackItem>
                        <Content>
                          <h4>{exam.name}</h4>
                        </Content>
                      </StackItem>
                    </Stack>
                  </CardBody>

                  {exam.dateDescription && (
                    <CardFooter>
                      <Flex
                        justifyContent={{
                          default: "justifyContentSpaceBetween"
                        }}
                        alignItems={{
                          default: "alignItemsCenter"
                        }}
                        flexWrap={{
                          default: "wrap"
                        }}
                        spaceItems={{
                          default: "spaceItemsSm"
                        }}
                        style={{
                          width: "100%"
                        }}
                      >
                        <FlexItem>
                          <Label
                            color="cyan"
                            icon={<CalendarAltIcon />}
                          >
                            Planowany termin
                          </Label>
                        </FlexItem>

                        <FlexItem>
                          <Content component="strong">
                            {exam.dateDescription}
                          </Content>
                        </FlexItem>
                      </Flex>
                    </CardFooter>
                  )}
                </Card>
              </GridItem>
            ))}
          </Grid>
        </StackItem>
      )}

      {examInformation && (
        <>
        <StackItem>
          <Content>
            <h3>Jak wygląda egzamin?</h3>
          </Content>
        </StackItem>
        <Divider />
        <StackItem>
          <Content>
            <p>{examInformation}</p>
          </Content>
        </StackItem>
        </>
      )}
    </Stack>
  );
};


const DocumentsContent = ({
  documents = []
}) => {
  if (!documents.length) {
    return null;
  }

  return (
    <Grid hasGutter>
      {documents.map((document) => (
        <GridItem
          key={document.id}
          span={12}
          md={6}
        >
          <Card
            isCompact
            isFullHeight
          >
            <CardHeader>
              <Content component="h3">{document.title}</Content>
              <Divider />
            </CardHeader>
            <CardBody>
              <Content>
                

                {document.description && (
                  <p>{document.description}</p>
                )}
              </Content>
            </CardBody>
          </Card>
        </GridItem>
      ))}
    </Grid>
  );
};


const EducationDirectionLearningPath = ({
  learningPath = {}
}) => {
  const [activeTabKey, setActiveTabKey] =
    useState("internships");

  const {
    internships = {},
    exams = [],
    examInformation,
    documents = []
  } = learningPath;

  const handleTabSelect = (
    event,
    tabKey
  ) => {
    setActiveTabKey(tabKey);
  };

  return (
    <PageSection
      id="learning-path"
      className="education-direction-section"
      isWidthLimited
      aria-labelledby="education-direction-learning-path-title"
    >
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Content
                style={{
                  textAlign: "center"
                }}
              >
                <h2 id="education-direction-learning-path-title">
                  Jak wygląda nauka?
                </h2>

                <p>
                  Poznaj organizację praktyk zawodowych,
                  egzaminy oraz dokumenty, które możesz
                  uzyskać po ukończeniu szkoły.
                </p>
              </Content>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Card isGlass>
            <CardBody>
              <Tabs
                activeKey={activeTabKey}
                onSelect={handleTabSelect}
                aria-label="Informacje o przebiegu nauki"
                isBox
              >
                <Tab
                  eventKey="internships"
                  title={
                    <TabTitleText>
                      Praktyki zawodowe
                    </TabTitleText>
                  }
                >
                  <div
                    style={{
                      paddingBlock:
                        "var(--pf-t--global--spacer--lg)"
                    }}
                  >
                    <InternshipsContent
                      internships={internships}
                    />
                  </div>
                </Tab>

                <Tab
                  eventKey="exams"
                  title={
                    <TabTitleText>
                      Egzaminy zawodowe
                    </TabTitleText>
                  }
                >
                  <div
                    style={{
                      paddingBlock:
                        "var(--pf-t--global--spacer--lg)"
                    }}
                  >
                    <ExamsContent
                      exams={exams}
                      examInformation={examInformation}
                    />
                  </div>
                </Tab>

                <Tab
                  eventKey="documents"
                  title={
                    <TabTitleText>
                      Co otrzymasz po ukończeniu?
                    </TabTitleText>
                  }
                >
                  <div
                    style={{
                      paddingBlock:
                        "var(--pf-t--global--spacer--lg)"
                    }}
                  >
                    <DocumentsContent
                      documents={documents}
                    />
                  </div>
                </Tab>
              </Tabs>
            </CardBody>
          </Card>
        </StackItem>
      </Stack>
    </PageSection>
  );
};


export default EducationDirectionLearningPath;